import React, { useEffect, useState } from 'react';
import { string, func } from 'prop-types';
import { Col, Row } from '@thd-olt-component-react/core-ui';
import { ErrorBoundary } from '@thd-olt-component-react/error-boundary';
import { Breadcrumbs } from '@thd-olt-component-react/breadcrumbs';
import { ProductInfoBar } from '@thd-olt-component-react/product-info-bar';
import { DynamicRecsWrapper } from '@thd-olt-component-react/thd-recs-containers';
import { Discontinued } from '@thd-olt-component-react/discontinued';
import { ProductDetails } from '@thd-olt-component-react/product-details';
import { Sharebelt, ShareBeltPrint, ShareBeltShareButton, ShareFavorite } from '@thd-olt-component-react/thd-sharebelt';
import { MediaGalleryDesktop } from '@thd-olt-component-react/media-gallery';
import { Price } from '@thd-olt-component-react/price';
import { ConsumerCardMessaging } from '@thd-olt-component-react/consumer-card-messaging';
import { SalientListItem, SalientPoints } from '@thd-olt-component-react/salient-points';
import { SuperSku } from '@thd-olt-component-react/super-sku';
import ZoneCard from '../zone-card';
import { SpecialOrderMessage } from './SpecialOrderMessage';
import { StoreInfo } from './StoreInfo';
import { RECS_REQUEST_KEY } from '../../../../constants';
import { shouldDisplayReferrerRecommendations } from '../../product-utils';

export const ProductHDDC = ({
  itemId,
  channel,
  onChange
}) => {

  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
  }, []);

  return (
    <>
      <Row className="u--paddingTop u--paddingBottom">
        <Col sm="7" flatten>
          <ErrorBoundary name="breadcrumbs">
            <Breadcrumbs
              itemId={itemId}
            />
          </ErrorBoundary>
        </Col>
        <Col sm="5" flatten className="u__flex-end">
          <ErrorBoundary name="product-info-bar">
            <ProductInfoBar itemId={itemId} padded />
          </ErrorBoundary>
        </Col>
      </Row>
      {mounted && shouldDisplayReferrerRecommendations() && (
        <Row id="recs:organic_search">
          <ErrorBoundary name="recs:organic_search">
            <Col nopadding>
              <DynamicRecsWrapper
                schemaName="pipsem"
                anchorId={itemId}
                errorBoundary
                hideATC
                requestKey={RECS_REQUEST_KEY}
                hydrator={{
                  className: 'grid',
                  tag: ZoneCard,
                  delay: 0,
                  scrollBuffer: 0,
                  id: 'pipsem'
                }}
              />
            </Col>
          </ErrorBoundary>
        </Row>
      )}
      <Row>
        <ErrorBoundary name="zone-a">
          <Col nopadding>
            <Row>
              <Col>
                <ErrorBoundary name="discontinued">
                  <Discontinued itemId={itemId} />
                </ErrorBoundary>
              </Col>
              <Col sm="7" flatten>
                <ZoneCard className="overflow u__clearfix">
                  <Row>
                    <Col sm="12">
                      <ErrorBoundary name="product-details">
                        <ProductDetails itemId={itemId}>
                          <ProductDetails.Badge itemId={itemId} />
                          <ProductDetails.BrandCollection showBrandHyperLink />
                          <div className="product-details__badge-title--wrapper">
                            <ProductDetails.Title />
                          </div>
                          <div className="product-details__favorites">
                            <Sharebelt itemId={itemId}>
                              <ShareFavorite showCircle />
                            </Sharebelt>
                          </div>
                        </ProductDetails>
                      </ErrorBoundary>
                    </Col>
                  </Row>
                  <Col sm="12">
                    <ErrorBoundary name="media-gallery-desktop">
                      <MediaGalleryDesktop
                        itemId={itemId}
                        showLoader
                        highRes
                        hover
                        mainImageFetchPriority="high"
                      />
                    </ErrorBoundary>
                  </Col>
                  <Col>
                    <ErrorBoundary name="sharebelt">
                      <Sharebelt horizontal itemId={itemId}>
                        <ShareBeltShareButton email />
                        <ShareBeltPrint />
                      </Sharebelt>
                    </ErrorBoundary>
                  </Col>
                </ZoneCard>
              </Col>
              <Col sm="5" flatten className="buyarea-wrapper">
                <div className="overflow">
                  <Row>
                    <ZoneCard>
                      <Col className="overflow">
                        <ErrorBoundary name="price">
                          <Price
                            channel="desktop"
                            displayEachUom={false}
                            itemId={itemId}
                            large
                            disableRangePricing
                            skip
                          />
                        </ErrorBoundary>
                      </Col>

                      <Col className="overflow consumer-credit-messaging__card">
                        <ErrorBoundary name="consumer-card-messaging">
                          <ConsumerCardMessaging
                            itemId={itemId}
                            clsRemediation={{
                              placeholders: true,
                              preservePlaceholders: true
                            }}
                          />
                        </ErrorBoundary>
                      </Col>
                    </ZoneCard>
                    <ZoneCard>
                      <Col>
                        <ErrorBoundary name="salient">
                          <SalientPoints itemId={itemId} max={3}>
                            <SalientListItem>
                              {/* eslint-disable-next-line */}
                              <a className="u__default-link" href="#product-overview">See More Details</a>
                            </SalientListItem>
                          </SalientPoints>
                        </ErrorBoundary>
                      </Col>
                    </ZoneCard>
                    <ZoneCard>
                      <Col className="overflow">
                        <ErrorBoundary name="super-sku">
                          <SuperSku
                            itemId={itemId}
                            onChange={onChange}
                          />
                        </ErrorBoundary>
                      </Col>
                    </ZoneCard>
                    <ZoneCard>
                      <ErrorBoundary name="special-order-message">
                        <SpecialOrderMessage />
                      </ErrorBoundary>
                    </ZoneCard>
                    <ZoneCard className="store">
                      <ErrorBoundary name="store-info">
                        <StoreInfo channel={channel} />
                      </ErrorBoundary>
                    </ZoneCard>
                  </Row>
                </div>
              </Col>
            </Row>
          </Col>
        </ErrorBoundary>
      </Row>
    </>
  );
};

ProductHDDC.propTypes = {
  itemId: string.isRequired,
  channel: string.isRequired,
  onChange: func.isRequired
};
